import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const OverageBasic = (props: {rowData: [], field: string, namedItems: {}, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>(_.get(props, "rowData.overagedetail"));

  const emptyRecord = {
    percent: null
  }

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field]['state'] !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    _.set(nextData, field, val)
    delete nextData.amtType
    delete nextData.items
    setData(nextData);
    props.persist({...nextData, state: 'basic'}, 'overagedetail', props.rowData)
  }

  const attrs = (field) => field_attrs('rentroll', props.field)(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Amt</label>
          <NumberInput
            field="percent"
            className="automated billion-input"
            data={data}
            attrs={attrs}
            min={0}
            max={100}
            readPrecision={4}
            writePrecision={4}
            persist={updateData}/>
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default OverageBasic
